jQuery(document).ready(function($) {

	if($('.images').length && $('.images .slide').length > 1){
		let $carousel = new Flickity( '.images', {
			cellAlign: 'center',
			contain: true,
			prevNextButtons: false,
			adaptiveHeight: true,
			fade: true,
			autoPlay: 3000,
			pauseAutoPlayOnHover: false,
			selectedAttraction: 0.025,
			friction: 0.9,
			on:{
				ready: function(){
					if( $('.images').find('.flickity-slider').children().length <= 1){
						$('.flickity-page-dots').hide();
					}
				}
			}
		});

		setTimeout(function(){
			$carousel.resize();
		}, 1000);
	}


	if($('.imagesWithCaptions').length){
		let currentSlideCount = $('.slide-count--current');

		let $captions = new Flickity( '.imageCaptions', {
			cellAlign: 'center',
			draggable: false,
			contain: true,
			prevNextButtons: false,
			adaptiveHeight: true,
			fade: true,
			pageDots: $('.imagesWithCaptions').data('disable-dots') ? false : true,
			asNavFor: '.imagesWithCaptions',
			selectedAttraction: 0.075,
			friction: 0.8,
			accessibility: false
		});

		let $carousel = new Flickity( '.imagesWithCaptions', {
			cellAlign: 'center',
			contain: true,
			prevNextButtons: false,
			pageDots: $('.imagesWithCaptions').data('disable-dots') ? false : true,
			arrowShape: 'M 50.8 21 L 54.3 24.5 L 32.59 46.3 L 79.5 46.3 L 79.5 51.3 L 32.6 51.3 L 54.3 73 L 50.8 76.5 L 23 48.8 Z',
			adaptiveHeight: true,
			fade: true,
			pauseAutoPlayOnHover: true,
			selectedAttraction: 0.025,
			friction: 0.9,
			on:{
				ready: function(){
					if( $('.imagesWithCaptions').find('.flickity-slider').children().length <= 1){
						$('.flickity-page-dots').hide();
					}
					else{
						currentSlideCount.text( this.selectedIndex + 1 );

					}
				},
				change: function(index){
					currentSlideCount.text( index + 1 );

					window.setTimeout(function(){
						$carousel.unpausePlayer();
					}, 1000);
				}
			}
		});

		$carousel.on( 'change', function( index ) {
  			if( $($carousel.selectedElement).attr('data-media-type') === "video" ){
  				if (window.outerWidth > 599) {
  					videoPlayers[0].play();
  				}
  			}
  			else{
  				videoPlayers[0].pause();
  			}

		});

		$('.pause-carousel').click(function(){
			if($(this).hasClass('paused')){
				$(this).removeClass('paused');
				$carousel.next( true );
				$carousel.playPlayer();
				}
			else{
				$(this).addClass('paused');
				$carousel.stopPlayer();
			}

		});

		$('.flickity-prev-next-button.previous').click(function(){
			$carousel.pausePlayer();
			$carousel.previous( true );
		});


		$('.flickity-prev-next-button.next').click(function(){
			$carousel.pausePlayer();
			$carousel.next( true );
		});

		if ($('.carousel-select-cell').length) {
			$('.carousel-select-cell').click(function(e){
				e.preventDefault();
				$carousel.pausePlayer();
				$carousel.selectCell( $(this).data('slide-index') );
				$("html, body").animate( { scrollTop: 0 }, 400 );
		});
		}

		setTimeout(function(){
			$carousel.resize();
		}, 1000);
	}

	if($('.video-js').length){
		var player = videojs('videobg', {
			autoplay: 'muted',
			loop: true,
			prevNextButtons: true
		});
	}

	if($('.video-carousel-slide').length){
		var videoPlayers = [];

		for(let i = 0, length1 = $('.video-carousel-slide').length; i < length1; i++){

			var ele = $('.video-carousel-slide').eq(i);
			var id 	= ele.attr('id');

			var options = {
				controls: false,
				autoplay: 'muted',
				preload: true,
				loop: true
			}

			var player = videojs(id, options);

			// player.exitFullWindow(function() {
			// 	player.muted(true);
			// 	player.play();
			// });

			player.ready(function() {
				player.muted(true);
				player.play();
			});

			videoPlayers.push( player );
		}

		$('.btn-volume').click(function(e) {
			e.preventDefault();
			$(this).toggleClass('volume-up');

			if($(this).hasClass('volume-up')){
				videoPlayers[0].muted(false);
			}
			else{
				videoPlayers[0].muted(true);
			}
		});
	}

	var teamMembersCarouselSettings = {
		wrapAround: true,
		pageDots: false,
		pauseAutoPlayOnHover: false,
		cellAlign: 'center',
		arrowShape: 'M 50.8 21 L 54.3 24.5 L 32.59 46.3 L 79.5 46.3 L 79.5 51.3 L 32.6 51.3 L 54.3 73 L 50.8 76.5 L 23 48.8 Z'
	}

	let $teamCarousel = null;
	let teamMembers = document.querySelector('.team-members');

	if(teamMembers){
		if($(window).outerWidth() < 600){
			$teamCarousel = new Flickity( '.team-members' , teamMembersCarouselSettings);
		}

		$(window).resize(function(event) {
			if(window.innerWidth < 600){
				if(!$teamCarousel || typeof teamCarousel === 'undefined'){
					$teamCarousel = new Flickity( '.team-members' , teamMembersCarouselSettings);
				}
			}
			else{
				if($teamCarousel) $teamCarousel.destroy();
			}
		});
	}

/*	Formidable Submission
   	==========================================================================	*/
   	$(document).on( 'frmFormComplete', function( event, form, response ) {
		$('body').addClass('state--form-complete');
	});

	var check_field = $('#field_pay_by_check');

	if ($('body').hasClass('page-membership-initiation-full-2018')) {
		check_field = $('#field_pay_by_check2');
	}

	if ($('body').hasClass('page-membership-initiation-full-2019')) {
		check_field = $('#field_pay_by_check3');
	}

	if ($('body').hasClass('page-membership-initiation')) {
		check_field = $('#field_pay_by_check32');
	}

	if ($('body').hasClass('page-charter-membership-initiation')) {
		check_field = $('#field_pay_by_check33');
	}

	if ($('body').hasClass('page-corporate-membership-initiation')) {
		check_field = $('#field_pay_by_check332');
	}

	$('#check_submit').on('click', function(e) {

		if (check_field.val() != 'Yes') {
			e.preventDefault();
			check_field.val('Yes').attr('data-frmval', 'Yes');
			$('#check_submit').trigger('click');
		}

	});

	$('.check-deposit-form').on('click', '.frm_final_submit', function(e) {

		if (check_field.val() != 'No') {
			e.preventDefault();
			check_field.val('No').attr('data-frmval', 'No');
			$('.frm_final_submit').trigger('click');
		}

	});

	$('.frm_radio input').on('change', function() {
		$(this).parents('.frm_opt_container').find('label').removeClass('selected');
		$(this).parent('label').addClass('selected');
	});


	/*	Formidable Date Select Minimum Today
		========================================================================== */
	if( $('#form_offsite .frm_date') && typeof $.datepicker != 'undefined' ) {
		$.datepicker.setDefaults({
			minDate:new Date()
		});
	}


	/*	Toggle Blocks
		========================================================================== */
	setupToggles();

	/*	Load Content Into Div
		========================================================================== */
	if( $('[data-load-content]').length ) {
		$('[data-load-content]').each(function(index, element) {
			var el = $(element);
			$.ajax({
				url: el.data('load-content'),
				success: function(data) {
					el.html(data);
					if( el.data('complete') ) {
						var complete_func = eval(el.data('complete'));
						if( typeof complete_func == 'function' ) complete_func();
					}
				}
			});
		});
	}

	var blog_images = $('.blog-post-content img:not(.blog-gallery-img)');
	if( blog_images.length > 1 ) {
		$('.blog-post-content').on('click', 'img:not(.blog-gallery-img)', function(event) {
			var images = [],
			start_index = 0,
			active_img = $(this).attr('src');
			
			blog_images.each(function(index, el) {
				images.push({
					src: $(this).data('src') ? $(this).data('src') : $(this).attr('src'),
					caption: $(this).attr('alt'),
					thumb: $(this).data('thumbnail') ? $(this).data('thumbnail') : $(this).attr('src')
				});
				if( active_img == $(this).attr('src') ) start_index = index;
			});

			blogFancy(null, images, start_index)
		}); 
	}

	var blog_gallery_images = $('.blog-post-content .blog-gallery-img');
	if( blog_gallery_images.length ) {
		
		$('.blog-post-content').on('click', '.blog-gallery-img', function(event) {
			blogFancy( $(this).data('gallery'), eval($(this).data('gallery')), $(this).data('id') )
		});

		// Supporting #gallery-[#]-[#] and ?share=gallery[#]-[#] to help with Twitter
		var open_gallery = false;
		if( window.location.hash.indexOf('#gallery') >= 0 ) open_gallery = window.location.hash;
		else if( typeof shared_gallery != 'undefined' ) {
			open_gallery = shared_gallery;
			// Remove the ?shared variables from URL to prevent dirtying it up on image open and change
			window.history.replaceState(null, '', `${window.location.origin}${window.location.pathname}#${open_gallery}`);
		}
		if( open_gallery ) {
			var gal = open_gallery.replace('#', '').split('-');
			blogFancy( gal[0], eval(gal[0]), gal[1] );
		}

		// Button to open the gallery, hidden visually unless focused, for accessibility purposes
		$('.blog-gallery-open').on('click', function() {
			$(this).next('.blog-gallery').find('.blog-gallery-image:first img').click();
		});
	}

	function blogFancy(id, images, start_index) {
		$.fancybox.open(images, {
			baseClass: 'blog-fancy',
			buttons: ['share','close'],
			loop: true,
			transitionDuration: 500,
			infobar: false,
			index: start_index,
			clickContent: false,
			thumbs : {
				autoStart : true,
				axis: "x"
			},
			hash: id,
			baseTpl:
			'<div class="fancybox-container" role="dialog" tabindex="-1">' +
			'<div class="fancybox-bg"></div>' +
			'<div class="fancybox-inner">' +
			'<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
			'<div class="fancybox-toolbar">{{buttons}}</div>' +
			'<div class="fancybox-navigation">{{arrows}}</div>' +
			'<div class="fancybox-stage"><div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div></div>' +
			'</div>' +
			'</div>',
			btnTpl: {
				arrowLeft: 
				'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
				'<div><svg class="l-inline" viewBox="0 0 29.7 9.2"><use xlink:href="#arrow2" /></svg></div>' +
				"</button>",
				arrowRight:
				'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
				'<div><svg class="l-inline" viewBox="0 0 29.7 9.2"><use xlink:href="#arrow2" /></svg></div>' +
				"</button>",
				close:
				'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
				'<svg class="" viewBox="0 0 20 20"><use xlink:href="#close" /></svg>' +
				"</button>",
				share: '<button data-fancybox-share class="fancybox-button fancybox-button--share ls-1" title="{{SHARE}}">' +
				'SHARE' +
				"</button>"
			},
			share: {
				url: function(instance, item) {
					var url = window.location.href;
					if( window.location.hash ) url = url.replace(window.location.hash, '');
					var sep = url.indexOf('?') >= 0 ? '&' : '?';
				  	return url + sep+'shared='+instance.currentHash;
				},
				tpl:
				  '<div class="fancybox-share">' +
				  "<h1>{{SHARE}}</h1>" +
				  "<p>" +
				  '<a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}">' +
				  '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg>' +
				  "<span>Facebook</span>" +
				  "</a>" +
				  '<a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}">' +
				  '<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg>' +
				  "<span>Twitter</span>" +
				  "</a>" +
				  "</p>" +
				  '<p data-clipboard-text="{{url_raw}}"><input class="fancybox-share__input" type="text" value="{{url_raw}}" /></p>' +
				  "</div>"
			  }
		});
	}

	$('body').on('click', '[data-size]', sizedWindow);

	$('[data-blog-toggle]').on('click', function() {
		$('body').toggleClass('nav-open');
	});

	$('.blog-return, .blog-close').on('click', function(event) {
		if( document.referrer == $(this).attr('href') ) {
			event.preventDefault();
			history.back();
		}
	});

	/*	Link Copying
	==========================================================================	*/
	var clipboard = new ClipboardJS('[data-clipboard-text]');
	clipboard.on('success', function(e) {
		$(e.trigger).addClass('copied');
		setTimeout($.proxy(function() { this.removeClass('copied'); }, $(e.trigger)), 1000);
		e.clearSelection();
	});

	// var header_height = $("#hdr").height();
	// var scrollWatch = debounce(function () {
	// 	//Method 2: Using toggleClass
	// 	$("#hdr").toggleClass("shrink", window.scrollY >= 30);
	// 	console.log(window.scrollY);
	// }, 150);
	// window.addEventListener('scroll',scrollWatch);

});

/* Custom Garden Tour Overlay */
$('.page-the-garden .iframe-aspect-ratio .btn, .page-tour-the-fc-collection .iframe-aspect-ratio .btn, .page-tour-the-field-house-collection .iframe-aspect-ratio .btn, .page-tour-the-offsite-collection .iframe-aspect-ratio .btn').click(function(e) {
	e.preventDefault();
	$(this).closest('.iframe-aspect-ratio').addClass('dissolve');

	window.setTimeout(function(){
		$(this).closest('.iframe-aspect-ratio').find('.inner-wrapper').contents().find('.circle-loader').click();

	}, 1000);
});

/* Toggle Blocks
   ========================================================================== */
function setupToggles() {
	var location_hash = window.location.hash.replace('#', '');

	$('.toggle-block').on('click', 'dt button', toggleBlocks);

	if( $('.toggle-block').length && location_hash ) {
		$('#'+location_hash).click();
	} else {
		$('[data-auto-open]').each(function(index, el) {
			$(el).find('dt:eq(0) button').click();
		});
	}
}

function toggleBlocks(event) {
	event.preventDefault();

	var button = $(this),
		dt = button.parents('dt'),
		content = dt.toggleClass('open').next('dd');

	button.attr('aria-expanded', dt.hasClass('open'));

	content.slideToggle('fast', function() {
		if( $(this).is(':hidden') ) $(this).attr('aria-hidden', true);
		else $(this).attr('aria-hidden', false);
	});


}

function sizedWindow(event) {
	
	var size = $(this).attr('data-size'),
		windowSize = [];
	
	if( typeof size == 'undefined' ) {
		windowSize[0] = '685';
		windowSize[1] = '505';
	} else windowSize = $(this).attr('data-size').toString().split(',');
	
	if( windowSize.length < 2 ) {
		windowSize[0] = '500';
		windowSize[1] = '400';
	}
	
	var shareWindow = window.open($(this).attr('href'), $(this).attr('title'), 'width='+windowSize[0]+',height='+windowSize[1]+',resizable=yes');
	if(shareWindow) event.preventDefault();		
}

/* Mobile Burger Navigation */
function toggleClassMenu() {
	if( !myMenu ) return;
	myMenu.classList.add("menu--animatable");
	if(!myMenu.classList.contains("menu--visible")) {
		myMenu.classList.add("menu--visible");
	} else {
		myMenu.classList.remove('menu--visible');
	}
}

function OnTransitionEnd() {
	myMenu.classList.remove("menu--animatable");
}

var myMenu = document.querySelector(".menu-nav");
var oppMenu = document.querySelector(".menu");
var closeMenu = document.querySelector(".btn--close");

if( myMenu ) myMenu.addEventListener("transitionend", OnTransitionEnd, false);
if( closeMenu ) closeMenu.addEventListener("click", toggleClassMenu, false);
if( oppMenu ) oppMenu.addEventListener("click", toggleClassMenu, false);
if( myMenu ) myMenu.addEventListener("click", toggleClassMenu, false);

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};